import React, { useEffect, useRef, useState } from 'react'
import {
  Row,
  Col,
  Card,
  Button,
  Image,
  Select,
  Input,
  Form,
  message,
  Modal,
  Checkbox,
  Tooltip,
  DatePicker,
  InputNumber,
} from 'antd'
import '../../css/regimen.scss'
import {
  EyeOutlined,
  EditOutlined,
  CloseCircleOutlined,
  ExclamationCircleOutlined,
  PlusCircleOutlined,
  ExclamationCircleFilled,
  DeleteFilled,
  CheckCircleFilled,
  CheckCircleOutlined,
  FileAddFilled,
} from '@ant-design/icons'

import '../../css/schedule.scss'
import moment from 'moment'
import { constants } from '../../constants'
import util from '../../util/util'
import _, { set } from 'lodash'

const FeedbackEditCard = ({
  handleRemove,
  form,
  isEdited,
  surgerydate,
  changeSchedule,
  patient,
  addForm,
  editform,
  hideButton,
  hide,
  setOpen,
  editpage,
  applyAllFeed,
  applyAndSkipToAllFeed
}) => {
  var [editDevice, setEditDevice] = useState(false)
  const [weekly, setWeekly] = useState()
  const [initState, setInitState] = useState()
  const [schtype, setSchtype] = useState(form?.scheduletype)
  const [forminst] = Form.useForm()
  const formRef = useRef(forminst)
  const [customvalue, setValue] = useState('')
  const [array, setArray] = useState(form.schedule)
  const diff = moment(Date.now())
    .startOf('day')
    .diff(moment(patient?.surgery?.date).startOf('day'), 'days')

  var [applyAll, setApplyAll] = useState(false)

  const cardRefs = [useRef(), useRef(), useRef()]
  const [observedHeight, setObservedHeight] = useState(0)
  var [skiponsurgerydate, setSkip] = useState(form.skiponsurgerydate)

  // Observer for tracking cardRefs[1] height
  useEffect(() => {
    const observer = new ResizeObserver((entries) => {
      for (let entry of entries) {
        const height = entry.target.offsetHeight
        console.log('setting height')
        setObservedHeight(height) // Update state when height changes
      }
    })

    if (cardRefs[1]?.current) {
      observer.observe(cardRefs[1].current)
    }

    return () => {
      if (cardRefs[1]?.current) {
        observer.unobserve(cardRefs[1].current)
      }
    }
  }, [])

  useEffect(() => {
    console.log('Height changed')
    const maxHeight = cardRefs[1].current?.offsetParent?.offsetHeight

    cardRefs.forEach((ref) => {
      if (ref.current?.offsetParent) {
        ref.current.offsetParent.style.height = `${maxHeight}px`
      }
    })
  }, [observedHeight])

  useEffect(() => {
    if (applyAll) return
    var temp = form.scheduletype ? form.scheduletype == 'weekly' : true
    setWeekly(temp)
    if (form.editnew) {
      setEditDevice(form.editnew)
      hideButton(true)
    }
    setSkip(form.skiponsurgerydate)
  }, [form])
  useEffect(() => {
    if (!hide && editDevice) setEditDevice(false)
  }, [hide])
  // useEffect(()=>{setWeekly(form.scheduletype=='weekly')},[])
  const typechange = (e) => {
    var type = form?.scheduletype ? form?.scheduletype : 'weekly'
    if (type != e) {
      formRef.current.setFieldsValue({
        schedule: [],
        startdate: 0,
        enddate: 0,
      })
      return
    }
    formRef.current.setFieldsValue({
      ...form,
      startdate: editpage
        ? moment(patient?.surgery?.date).add(form?.startdate, 'd')
        : form?.startdate ,
      enddate: editpage
        ? moment(patient?.surgery?.date).add(form?.enddate, 'd')
        : form?.enddate ,
      schedule: form?.schedule
        ? form?.schedule
        : form?.weekdays?.map((i) => {
            return _.find(constants.WEEKDAYS, { name: i })?.index
          }) || [],
      scheduletype: form?.scheduletype ? form?.scheduletype : 'weekly',
    })
  }

  var showConfirmeBoxSkipForAll = (e) => {
    Modal.confirm({
      title: `Do you want apply 'Skip on surgery date' to all feedback forms?`,
      icon: <ExclamationCircleFilled />,
      content: '',
      okText: 'Yes',
      cancelText: 'No',
      onOk: () => handleAndSkipToAll(e),
      onCancel: () => handleSubmit(e),
    })
  }

  const handleSubmit = (e) => {
    isEdited(true)

    if (form.editnew) form.editnew = false
    if (!e.schedule) e.schedule = [1]
    if (e.scheduletype == 'custom') e.schedule = array
    var editedform =
      e.scheduletype == 'custom'
        ? { ...form, ...e, startdate: 0, enddate: 0 }
        : { ...form, ...e }
      editedform.skiponsurgerydate = skiponsurgerydate || false
    if (applyAll) {
      showConfirmeBox({ editnew: false, ...editedform })
    }
    else {
      editform(editedform)
      setEditDevice(false)
      hideButton(false)
    }
  }

  const handleAndSkipToAll = (e) => {
    isEdited(true)

    if (form.editnew) form.editnew = false
    if (!e.schedule) e.schedule = [1]
    if (e.scheduletype == 'custom') e.schedule = array
    var editedform =
      e.scheduletype == 'custom'
        ? { ...form, ...e, startdate: 0, enddate: 0 }
        : { ...form, ...e }
    editedform.skiponsurgerydate = skiponsurgerydate || false

      applyAndSkipToAllFeed(editedform)
      setEditDevice(false)
      hideButton(false)
  }

  var showConfirmeBox = (e,skipToAll=false) => {
    Modal.confirm({
      title: 'Are you sure you want apply this schedule to all ?',
      icon: <ExclamationCircleFilled />,
      content: '',
      okText: 'Yes',
      cancelText: 'No',
      onOk: () => {
        setApplyAll(false)
        applyAllFeed(e,skipToAll)
        setEditDevice(false)
        hideButton(false)
      },
      onCancel: () => {
        if (skipToAll) applyAllFeed(e, skipToAll)(e,skipToAll)
        setApplyAll(false)
        onclose(e)
      },
    })
  }
  var getDays = (date) =>
    moment(date)
      .startOf('day')
      .diff(moment(patient?.surgery?.date).startOf('day'), 'days')

  const handleChange = (e) => {
    const inputValue = e.target.value

    // Validate input: allow only numbers and commas
    const validValue = inputValue.replace(/[^0-9,-]/g, '')

    // Update input value
    setValue(validValue)

    const numberArray = validValue
      .split(',')
      .filter((val) => val.trim() !== '')
      .map((val) => parseFloat(val)) // Convert each element to a number

    setArray([
      ...new Set(
        numberArray.sort(function (a, b) {
          return a - b
        })
      ),
    ])
  }
  var renderIntervalOptions = () => {
    return constants.WEEKDAYS.map((d) => {
      return <Select.Option value={d.index}>{d.display_name}</Select.Option>
    })
  }
  var showConfirmDeleteBox = (e) => {
    console.log(e, form)
    Modal.confirm({
      title: 'Are you sure you want delete this Questionnaire form ?',
      icon: <ExclamationCircleFilled />,
      content: '',
      okText: 'Yes',
      cancelText: 'No',
      onOk: () => {
        isEdited(true)
        hideButton(false)
        handleRemove(e)
      },
    })
  }

  var onclose = (e, editstop = false) => {
    isEdited(false)
    form.scheduletype ? setSchtype(form.scheduletype) : setSchtype('weekly')
    form.scheduletype
      ? setWeekly(form.scheduletype == 'weekly')
      : setWeekly(true)
    formRef.current.setFieldsValue({
      ...form,
      startdate: editpage
        ? moment(patient?.surgery?.date).add(form?.startdate , 'd')
        : form?.startdate ,
      enddate: editpage
        ? moment(patient?.surgery?.date).add(form?.enddate , 'd')
        : form?.enddate ,
      schedule: form?.schedule
        ? form?.schedule
        : form?.weekdays?.map((i) => {
            return _.find(constants.WEEKDAYS, { name: i })?.index
          }) || [1],
      scheduletype: form?.scheduletype ? form?.scheduletype : 'weekly',
    })
    if (form.editnew) {
      handleSubmit(e)
    }
    setEditDevice(editstop)
    hideButton(editstop)
  }

  return (
    <Card id={'feedschedcardview'} bordered={false}>
      <Row>
        <Col style={{ width: '100%' }}>
          {form ? (
            <Col className='assignedContainer'>
              <Row>
                <Row
                  className='selectorContainer'
                  gutter={25}
                  style={{ width: '100%' }}
                >
                  <Row className='connectorLine_1 devconnectorline' />
                  <Col className='exerciseColCenter divide' flex={'30%'}>
                    <Card
                      bordered={false}
                      className='deviceRow feeditem'
                      style={{ display: 'flex', justifyContent: 'center' }}
                      align='middle'
                    >
                      <div
                        ref={cardRefs[0]}
                        style={{ display: 'flex', flexDirection: 'row' }}
                      >
                        <Col className='noPadding min-width'>
                          <div className='noPadding'>
                            <Image
                              height={50}
                              width={60}
                              className='exerImg'
                              src={constants.API_URL + '/' + form.image}
                              preview={false}
                            />
                            <row style={{ color: '#0070E0', fontSize: '12px' }}>
                              <EyeOutlined onClick={setOpen} />
                              &nbsp;
                              <a onClick={setOpen}>Preview</a>
                            </row>
                          </div>
                        </Col>
                        <Col className='confHeader noPadding'>
                          {form.shortname}
                        </Col>
                        {/* <div className='exerRow'>
            <Col className='exerHeader'>{form.display_name}</Col>
          </div> */}
                      </div>
                    </Card>
                  </Col>
                  <Col className='exerciseColCenter divide' flex={'58%'}>
                    <Card
                      bordered={false}
                      className='deviceRow feedschedcard'
                      style={{ maxWidth: '75%' }}
                    >
                      <div ref={cardRefs[1]}>
                        {editDevice ? (
                          <Col>
                            <Row>
                              <Form
                                form={forminst}
                                layout={'vertical'}
                                style={{
                                  display: 'flex',
                                  width: '100%',
                                  gap: '5px',
                                  gap: '5px',
                                }}
                                onFinish={(e) => {
                                  console.log('ert', e)
                                  if (editpage && e.scheduletype == 'weekly') {
                                    e.startdate = getDays(e.startdate)
                                    e.enddate = getDays(e.enddate)
                                  }
                                  // console.log('onfinishfeed',skiponsurgerydate)
                                  if(skiponsurgerydate && !applyAll) 
                                    showConfirmeBoxSkipForAll(e) 
                                    else handleSubmit(e)
                                }}
                                initialValues={{
                                  ...form,
                                  startdate: editpage
                                    ? moment(patient?.surgery?.date).add(
                                        form?.startdate ,
                                        'd'
                                      )
                                    : form?.startdate ,
                                  enddate: editpage
                                    ? moment(patient?.surgery?.date).add(
                                        form?.enddate ,
                                        'd'
                                      )
                                    : form?.enddate ,
                                  schedule: form?.schedule
                                    ? form?.schedule
                                    : form?.weekdays?.map((i) => {
                                        return _.find(constants.WEEKDAYS, {
                                          name: i,
                                        })?.index
                                      }) || [],
                                  scheduletype: form?.scheduletype
                                    ? form?.scheduletype
                                    : 'weekly',
                                }}
                              >
                                <Form.Item label='Type' name='scheduletype'>
                                  <Select
                                    showSearch
                                    filterOption={(input, option) =>
                                      option.children
                                        .toLowerCase()
                                        .indexOf(input.toLowerCase()) >= 0
                                    }
                                    defaultValue='weekly'
                                    onChange={(e) => {
                                      typechange(e)
                                      setSchtype(e)
                                      setWeekly(e == 'weekly')
                                    }}
                                  >
                                    <Select.Option value='weekly'>
                                      Weekly
                                    </Select.Option>
                                    <Select.Option value='custom'>
                                      Custom
                                    </Select.Option>
                                  </Select>
                                </Form.Item>
                                {!weekly ? (
                                  // <Form.Item label="Day" rules={[
                                  //         {
                                  //           required: true,
                                  //           message: "Please select start date.",
                                  //         },
                                  //  () => ({
                                  //     validator(rule, value) {
                                  //       if (value == 0) {
                                  //         return Promise.resolve();
                                  //       }
                                  //       return Promise.reject(
                                  //         "Please enter number lesser or greater than zero!"
                                  //       );
                                  //     },
                                  //   }),
                                  // ]}   name='schedule'>
                                  <div
                                    style={{ width: '180px', height: '33px' }}
                                  >
                                    <Form.Item
                                      label='Days'
                                      name={'schedule'}
                                      rules={[
                                        {
                                          required: true,
                                          message: 'Please select days.',
                                        },
                                        () => ({
                                          validator(rule, value) {
                                            const reg = /[^0-9-,]/
                                            if (reg.test(value))
                                              return Promise.reject(
                                                'Please enter numeric day'
                                              )
                                            return Promise.resolve()
                                          },
                                        }),
                                      ]}
                                    >
                                      <Input
                                        value={customvalue}
                                        onChange={handleChange}
                                        style={{
                                          width: '100%',
                                          height: '33px',
                                        }}
                                      />
                                    </Form.Item>
                                  </div>
                                ) : (
                                  // {/* </Form.Item> */}
                                  <>
                                    {' '}
                                    <Form.Item
                                      label='Week days'
                                      name='schedule'
                                      rules={[
                                        // {
                                        //   required: true,
                                        //   message: "Please select start date.",
                                        // },
                                        () => ({
                                          validator(rule, value) {
                                            console.log(array)
                                            if (!value || value.length > 0) {
                                              return Promise.resolve()
                                            }
                                            return Promise.reject(
                                              'Please select week days!'
                                            )
                                          },
                                        }),
                                      ]}
                                    >
                                      <Select
                                        showSearch
                                        filterOption={(input, option) =>
                                          option.children
                                            .toLowerCase()
                                            .indexOf(input.toLowerCase()) >= 0
                                        }
                                        mode='multiple'
                                        style={{
                                          width: '100px',
                                          height: '34px',
                                          overflow: 'scroll',
                                        }}
                                        defaultValue={1}
                                        required
                                      >
                                        {renderIntervalOptions()}
                                      </Select>
                                    </Form.Item>
                                    <Form.Item
                                      label='Start'
                                      name='startdate'
                                      className='formInput'
                                      rules={[
                                        {
                                          required: true,
                                          message: 'Please select start date.',
                                        },
                                        () => ({
                                          validator(rule, value) {
                                            console.log(typeof value, value)
                                            if (!editpage)
                                              value = moment(
                                                patient?.surgery?.date
                                              ).add(parseInt(value, 10), 'days')
                                            if (
                                              moment(value)
                                                .startOf('day')
                                                .isSameOrAfter(
                                                  moment().startOf('day')
                                                )
                                            ) {
                                              return Promise.resolve()
                                            }
                                            return Promise.reject(
                                              `select ${
                                                editpage ? 'date' : 'days'
                                              } ${
                                                editpage
                                                  ? moment()
                                                      .add(diff)
                                                      .format('MM/DD/YYYY')
                                                  : diff
                                              } or greater!`
                                            )
                                          },
                                        }),
                                      ]}
                                    >
                                      {!editpage ? (
                                        <InputNumber
                                          style={{ minWidth: 68 }}
                                          type='number'
                                        />
                                      ) : (
                                        <DatePicker showToday={false} />
                                      )}
                                    </Form.Item>
                                    <Form.Item
                                      label='End'
                                      name='enddate'
                                      className='formInput'
                                      rules={[
                                        {
                                          required: true,
                                          message: 'Please select end date.',
                                        },
                                        ({ getFieldValue }) => ({
                                          validator(rule, value) {
                                            let start =
                                              getFieldValue('startdate')
                                            if (!editpage) {
                                              value = moment(
                                                patient?.surgery?.date
                                              ).add(value)
                                              start = moment(
                                                patient?.surgery?.date
                                              ).add(start)
                                            }
                                            if (
                                              moment(value)
                                                .startOf('day')
                                                .isSameOrAfter(
                                                  moment().startOf('day')
                                                ) &&
                                              moment(value)
                                                .startOf('day')
                                                .isSameOrAfter(
                                                  start.startOf('day')
                                                )
                                            ) {
                                              return Promise.resolve()
                                            }
                                            return Promise.reject(
                                              `select ${
                                                editpage ? 'date' : 'days'
                                              } today or greater`
                                            )
                                          },
                                        }),
                                      ]}
                                    >
                                      {!editpage ? (
                                        <InputNumber
                                          style={{ minWidth: 68 }}
                                          type='number'
                                          required
                                        />
                                      ) : (
                                        <DatePicker showToday={false} />
                                      )}
                                    </Form.Item>
                                  </>
                                )}
                                <Button
                                  style={{ all: 'unset' }}
                                  type='button'
                                  htmlType='submit'
                                >
                                  <CheckCircleOutlined
                                    style={{ fontSize: '27px', margin: '10px' }}
                                    className='editIcon'
                                  />
                                </Button>

                                <Button
                                  style={{ all: 'unset' }}
                                  onClick={(e) => {
                                    // isEdited(false)
                                    // form.scheduletype?setSchtype(form.scheduletype):setSchtype('weekly');
                                    // form.scheduletype?setWeekly(form.scheduletype=='weekly'):setWeekly(true);
                                    // formRef.current.setFieldsValue({
                                    //             ...form,
                                    //             startdate:editpage? moment(patient?.surgery?.date).add((form?.startdate ), "d") :(form?.startdate  ),
                                    //             enddate:editpage? moment(patient?.surgery?.date).add((form?.enddate ), "d") :(form?.enddate  ),
                                    //                 schedule:(form?.schedule)? form?.schedule : form?.weekdays?.map(i=> {return _.find(constants.WEEKDAYS,{name:i})?.index}) || [],
                                    //                 scheduletype:(form?.scheduletype )?form?.scheduletype:'weekly'
                                    //         })
                                    // if(form.editnew) {handleSubmit(e) }
                                    // setEditDevice(false);hideButton(false)
                                    onclose(e)
                                  }}
                                >
                                  <CloseCircleOutlined
                                    style={{ fontSize: '27px' }}
                                    className='editIcon'
                                  />
                                </Button>
                              </Form>
                              {!weekly && '*Comma separated for multiple days'}
                            </Row>
                            <Row>
                              <Checkbox
                                checked={skiponsurgerydate}
                                onChange={(e) => setSkip(e.target.checked)}
                              >
                                Skip on surgery date
                              </Checkbox>
                              <Checkbox
                                style={{ marginLeft: '54%' }}
                                value={applyAll}
                                onChange={() => setApplyAll(!applyAll)}
                              >
                                Apply to all
                              </Checkbox>
                            </Row>
                          </Col>
                        ) : (
                          <Col
                            style={{
                              flexDirection: 'row',
                              display: 'flex',
                              justifyContent: 'space-between',
                            }}
                          >
                            {(
                              !editDevice && form.scheduletype
                                ? form.scheduletype != 'weekly'
                                : false
                            ) ? (
                              <div
                                style={{ width: '100%', maxHeight: '140px' }}
                              >
                                <Row
                                  className='ant-scroll-container'
                                  style={{ width: '85%', height: '100%' }}
                                >
                                  {form.schedule
                                    .sort(function (a, b) {
                                      return a - b
                                    })
                                    .map((i) => (
                                      <Col
                                        className='confHeader'
                                        style={{ margin: '10px' }}
                                        flex={'auto'}
                                      >
                                        <Row>
                                          S
                                          {i >= 0
                                            ? '+' + i.toString() || '-15'
                                            : i?.toString() || '-15'}
                                        </Row>
                                        <Row>
                                          {moment(patient?.surgery?.date)
                                            .add(i, 'd')
                                            .format('MM/DD/YYYY')}
                                        </Row>
                                      </Col>
                                    ))}
                                </Row>
                              </div>
                            ) : (
                              <>
                                <Col className='confHeader' flex={'auto'}>
                                  <Row>
                                    S
                                    {form?.startdate >= 0
                                      ? '+' + form?.startdate?.toString() ||
                                        '-15'
                                      : form?.startdate?.toString() || '-15'}
                                  </Row>
                                  <Row>
                                    {moment(patient?.surgery?.date)
                                      .add(form?.startdate, 'd')
                                      .format('MM/DD/YYYY')}
                                  </Row>
                                </Col>
                                <Col className='confHeader' flex={'auto'}>
                                  To
                                </Col>
                                <Col className='confHeader' flex={'auto'}>
                                  <Row>
                                    S
                                    {form?.enddate >= 0
                                      ? '+' + form?.enddate?.toString() || '+15'
                                      : form?.enddate?.toString() || '+15'}
                                  </Row>
                                  <Row>
                                    {moment(patient?.surgery?.date)
                                      .add(form?.enddate, 'd')
                                      .format('MM/DD/YYYY')}
                                  </Row>
                                </Col>
                              </>
                            )}

                            <Row style={{ offset: '100%' }}>
                              <EditOutlined
                                style={{ fontSize: '20px', marginTop: '25px' }}
                                hidden={hide}
                                onClick={() => {
                                  onclose(form, true)
                                  setEditDevice(true)
                                  hideButton(true)
                                }}
                              />
                            </Row>

                            <Col> </Col>
                          </Col>
                        )}

                        {!editDevice &&
                          (!form.scheduletype ||
                            form.scheduletype == 'weekly') && (
                            <p
                              className='confHeader'
                              style={{ paddingLeft: '24px', paddingTop: '5px' }}
                            >
                              Weekdays:{' '}
                              {form?.schedule
                                ? form?.schedule
                                    .sort()
                                    .map((i) => {
                                      if (form.scheduletype == 'custom')
                                        console.log('QRT', i, form)
                                      return _.find(constants.WEEKDAYS, {
                                        index: i,
                                      })?.name
                                    })
                                    .map((i) => i[0].toUpperCase() + i.slice(1))
                                    .join(', ')
                                : form?.weekdays
                                    ?.map(
                                      (i) => i[0].toUpperCase() + i.slice(1)
                                    )
                                    .join(', ')}
                              <br />
                            </p>
                          )}
                        {!editDevice && form.scheduletype == 'custom' && (
                          <p
                            className='confHeader'
                            style={{ textAlign: 'center', paddingTop: '15px' }}
                          >
                            {`Custom Days (S+)`}:
                            {form?.schedule
                              ?.sort(function (a, b) {
                                return a - b
                              })
                              .join(', ')}{' '}
                            <br />
                          </p>
                        )}
                      </div>
                    </Card>
                  </Col>
                  <Col flex={'10%'}>
                    <Card
                      style={{ display: 'flex', justifyContent: 'center' }}
                      className='deviceRow'
                      align='middle'
                    >
                      <div ref={cardRefs[2]}>
                        <DeleteFilled
                          id={'deleteform'}
                          style={{ fontSize: '25px' }}
                          onClick={() => showConfirmDeleteBox(form?.index)}
                        />
                      </div>
                    </Card>
                  </Col>
                </Row>
              </Row>
            </Col>
          ) : null}
        </Col>
      </Row>
    </Card>
  )
}
export default FeedbackEditCard
